// NaN for blank/non-numeric cells so compareCells can fall back to text sorting.
export const toNumber = (value: string): number => {
  if (value.trim() === "") {
    return NaN;
  }
  return Number(value);
};

export const compareCells = (a: string, b: string): number => {
  const numA = toNumber(a);
  const numB = toNumber(b);
  if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
    return numA - numB;
  }
  // Sort all numeric cells ahead of non-numeric ones so the ordering stays
  // transitive (a mixed numeric/text path would otherwise break Array.sort).
  if (!Number.isNaN(numA)) {
    return -1;
  }
  if (!Number.isNaN(numB)) {
    return 1;
  }
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
};
